<template>
  <v-container fluid class="fill-height">
    <v-row no-gutters class="full-height">
      <v-col no-gutters cols="12">
        <v-row
          align="start"
          justify="space-between"
          class="row-section row-odd"
        >
          <v-col cols="4" class="widget-top widget-left inner"></v-col>
          <v-col cols="4" class="widget-top widget-center inner"></v-col>
          <v-col cols="4" class="widget-top widget-right inner">
            <language-switcher />
          </v-col>
        </v-row>
        <v-row
          align="center"
          justify="space-between"
          class="row-section row-even"
        >
          <v-col cols="4" class="widget-middle widget-left inner"></v-col>
          <v-col
            cols="4"
            class="centered-login widget-middle widget-center inner"
          >
            <!-- LOGIN COMPONENTS -->
            <h3 v-if="!networkOnLine" class="offline-msg">
              {{ $t('connection.notConnected') }}
            </h3>
            <Login v-if="networkOnLine" />
            <!-- END LOGIN COMPONENTS -->
          </v-col>
          <v-col cols="4" class="widget-middle widget-right inner"></v-col>
        </v-row>
        <v-row align="end" justify="space-between" class="row-section row-odd">
          <v-col cols="4" class="widget-bottom widget-left inner"></v-col>
          <v-col cols="4" class="widget-bottom widget-center inner"></v-col>
          <v-col cols="4" class="widget-bottom widget-right inner"></v-col>
        </v-row>
      </v-col>
    </v-row>
    <div v-html="photoSource" id="photo-attrib"></div>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import LanguageSwitcher from '../../components/LoggedOut/LanguageSwitcher'
import Login from '../../auth/Login'

export default {
  components: {
    Login,
    LanguageSwitcher
  },
  props: {
    photoSource: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState('app', ['networkOnLine'])
  }
}
</script>

<style lang="scss">
#photo-attrib {
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 10px;
  font-weight: 200;
  color: white;
  z-index: 1000;
  a{
    font-weight: 300;
    color: white;
    &:hover{
      color: white;
    }
  }
}
</style>
